import { PBPGetResponse } from '@percent/utility'
import { CountriesServiceCapabilities, Country } from './countries.types'

export const countriesService = ({ client }: CountriesServiceCapabilities) => ({
  getCountries: () =>
    client.get<PBPGetResponse<Country[]>>('/v1/countries', {
      params: {
        hasRegistry: true,
      },
      withCredentials: true,
    }),
})
